import useWebSocketDefault from "react-use-websocket";

export const useWebSocket: typeof useWebSocketDefault =
  // @ts-expect-error some ESM<>CJS mess
  useWebSocketDefault?.default ?? useWebSocketDefault;
